import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogActions, DialogContent,
  Button, Paper, Typography, MenuItem, Select, FormControl
} from '@mui/material';

export default function ReorderDialogWithDropDown({ open, onClose, data, onSave }) {
  
  //const [items, setItems] = useState(data);
   const [items, setItems] = useState(() =>
    data.map((item) => ({
      ...item,
      rank: 'N/A' // default value
    }))
  );

   const usedRanks = items
    .map((item) => item.rank)
    .filter((rank) => rank !== 'N/A');

  const numberOptions = Array.from({ length: 50 }, (_, i) => (i + 1).toString());

  const handleRankChange = (index, newRank) => {
    const updated = [...items];
    updated[index].rank = newRank;
    setItems(updated);
  };

  const handleSave = () => {
    onSave(items);
    onClose();
  };

  function SortableItem({ item, index }) {
    const style = {
      margin: '8px 0',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      border: '1px solid #ccc',
      borderRadius: 8,
      background: '#fff',
      cursor: 'grab'
    };
  
    return (
      <Paper style={style} >
         <Typography variant="body2" fontWeight={600} width={60}>Rank #</Typography>
         <FormControl size="small" sx={{width:80, mr:2}}>
          <Select
            value={item.rank}
            onChange={(e) => handleRankChange(index, e.target.value)}
          >
            <MenuItem value="N/A">N/A</MenuItem>
            {numberOptions.map((num) => (
              <MenuItem
                key={num}
                value={num}
                disabled={
                  usedRanks.includes(num) && item.rank !== num
                }
              >
                {num}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <img src={item?.multimedia?.[0]?.url} alt="" width={48} height={48} style={{ borderRadius: 8 }} />
        <Typography>{item.displayName}</Typography>
      </Paper>
    );
  }
  
  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Set Order of Items</DialogTitle>
      <DialogContent dividers>
             {items.map((item,index) => (
              <SortableItem key={item.id} item={item}  index={index} />
            ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
